import React from 'react';
import { Input } from 'reactstrap';
import { connect } from 'react-redux';
import { VMAIL_ROUTE } from '../../lib/constants';

const NumberRoute = ({ onChange, gateways, number, vmail, trunks, tdmRoutes }) => {
  const toSelectGateway = vmail ? VMAIL_ROUTE.gateway : number?.routeInfo?.gateway;
  let routeArr = gateways;

  if (number.carrier === 'inteliquent') routeArr = trunks.trunkGroupList;

  return (
    <Input type="select" onChange={e => onChange(e)} disabled={vmail}>
      {number.carrier === 'tdm' &&
        tdmRoutes?.map(route => (
          <option
            key={route.value}
            data-trunk={`${route.value}`}
            selected={tdmRoutes.some(el => el.value === route.value)}
          >
            {route.label}
          </option>
        ))}

      {number.carrier !== 'tdm' &&
        routeArr?.map(el => {
          return (
            <>
              {number.carrier === 'inteliquent' ? (
                <>
                  <option
                    key={el.trunkGroupName}
                    data-trunk={`${el.trunkGroupName}`}
                    value={JSON.stringify(el)}
                    selected={number.trunk === el.trunkGroupName}
                  >
                    {el.trunkGroupName}
                  </option>
                </>
              ) : (
                <option
                  key={el.route}
                  value={JSON.stringify(el)}
                  selected={el.gateway === toSelectGateway}
                  data-trunks={el.gateway}
                >
                  {el.gateway === '208.65.249.104:5080' ? 'unified.epik.io' : el.gateway}
                </option>
              )}
            </>
          );
        })}
    </Input>
  );
};
const mapStateToProps = state => ({
  gateways: state.AppState.provisioning.gateways,
  trunks: state.AppState.provisioning.trunkGroupList,
  tdmRoutes: state.AppState.tdmRoutes,
});

export default connect(
  mapStateToProps,
  null,
)(NumberRoute);
